module.exports = __webpack_public_path__ + "static/media/react-ppmemo-banner-small.de6d8468.jpg";